import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, Button } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';

const OtherProducts = () => {
    const productList = [
        {
            name: 'UrLawyers',
            description: 'Instant Legal Consultation',
            logo: 'https://www.mgfintech.com/assets/images/products/urlawyers.png',
            link: 'https://www.urlawyers.in',
            gradient: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
            accent: '#3b82f6',
        },
        {
            name: 'InCallers',
            description: 'Organized Calling & Messaging',
            logo: 'https://www.mgfintech.com/assets/images/products/incallers.png',
            link: 'https://www.incallers.com',
            gradient: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
            accent: '#ef4444',
        },
        {
            name: 'BRESA',
            description: 'Real Estate Super-App',
            logo: 'https://www.mgfintech.com/assets/images/products/bresa.png',
            link: 'https://www.bresa.in',
            gradient: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
            accent: '#10b981',
        },
        {
            name: 'OPTOKART',
            description: 'Eyewear in 3–24 Hours',
            logo: 'https://www.mgfintech.com/assets/images/products/optokart.png',
            link: 'https://www.optokart.com',
            gradient: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
            accent: '#06b6d4',
        },
        {
            name: 'iAnswerAI',
            description: 'AI Receptionist for Missed Calls',
            logo: 'https://www.mgfintech.com/assets/images/products/ianswerai.png',
            link: 'https://www.ianswerai.com',
            gradient: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
            accent: '#0ea5e9',
        },
        {
            name: 'NetVid',
            description: 'Decentralized Video Platform',
            logo: 'https://www.mgfintech.com/assets/images/products/netvid.png',
            link: 'https://www.netvid.in',
            gradient: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
            accent: '#8b5cf6',
        },
        {
            name: 'Mevorides',
            description: 'Electric Vehicle Ride Sharing',
            logo: 'https://www.mgfintech.com/assets/images/products/mevorides.jpg',
            link: 'https://www.mevorides.com',
            gradient: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
            accent: '#059669',
        },
    ];

    return (
        <Box sx={{
            backgroundColor: '#020617',
            py: 10,
            color: 'white',
            position: 'relative',
            overflow: 'hidden'
        }}>
            <Box sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '1px',
                background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent)'
            }} />

            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
                <Box sx={{ textAlign: 'center', mb: 8 }}>
                    <Typography
                        variant="h3"
                        component="h2"
                        sx={{
                            fontWeight: 800,
                            mb: 2,
                            background: 'linear-gradient(to right, #fff, #94a3b8)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            letterSpacing: '-0.02em'
                        }}
                    >
                        Other Products by MG Fintech
                    </Typography>
                    <Typography
                        variant="h6"
                        sx={{
                            color: '#64748b',
                            fontWeight: 400,
                            maxWidth: '600px',
                            mx: 'auto',
                            lineHeight: 1.6
                        }}
                    >
                        Explore our innovative suite of digital solutions designed to empower businesses and individuals
                    </Typography>
                </Box>

                <Grid container spacing={4}>
                    {productList.map((product) => (
                        <Grid item xs={12} sm={6} md={4} key={product.name}>
                            <Card
                                sx={{
                                    background: product.gradient,
                                    color: 'white',
                                    height: '100%',
                                    borderRadius: 5,
                                    border: '1px solid rgba(255, 255, 255, 0.05)',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                                    '&:hover': {
                                        transform: 'translateY(-12px)',
                                        boxShadow: `0 20px 40px -10px rgba(0, 0, 0, 0.5)`,
                                        border: `1px solid ${product.accent}`,
                                        '& .product-icon': {
                                            transform: 'scale(1.1) rotate(5deg)',
                                        },
                                    },
                                }}
                            >
                                <CardContent sx={{ p: 5, display: 'flex', flexDirection: 'column', height: '100%' }}>
                                    <Box
                                        className="product-icon"
                                        sx={{
                                            width: 80,
                                            height: 80,
                                            backgroundColor: 'white',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mb: 4,
                                            p: 1.5,
                                            transition: 'transform 0.4s ease',
                                            boxShadow: '0 0 20px rgba(255,255,255,0.1)'
                                        }}
                                    >
                                        <img
                                            src={product.logo}
                                            alt={`${product.name} logo`}
                                            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                        />
                                    </Box>

                                    <Typography variant="h4" component="h3" sx={{ fontWeight: 700, mb: 1.5, color: '#ffffff' }}>
                                        {product.name}
                                    </Typography>

                                    <Typography variant="body1" sx={{ color: '#cbd5e1', mb: 4, flexGrow: 1, lineHeight: 1.7 }}>
                                        {product.description}
                                    </Typography>

                                    <Button
                                        component="a"
                                        href={product.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        endIcon={<ArrowForward />}
                                        sx={{
                                            color: product.accent,
                                            textTransform: 'none',
                                            fontWeight: 700,
                                            fontSize: '1rem',
                                            p: 0,
                                            justifyContent: 'flex-start',
                                            '&:hover': { backgroundColor: 'transparent' },
                                        }}
                                    >
                                        Visit Website
                                    </Button>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>

                <Box sx={{ textAlign: 'center', mt: 10 }}>
                    <Box
                        component="a"
                        href="https://www.mgfintech.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            background: 'rgba(255, 255, 255, 0.03)',
                            backdropFilter: 'blur(10px)',
                            px: 4,
                            py: 2,
                            borderRadius: 50,
                            border: '1px solid rgba(255, 255, 255, 0.1)',
                            textDecoration: 'none',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                background: 'rgba(255, 255, 255, 0.08)',
                                borderColor: 'rgba(255, 255, 255, 0.3)',
                            }
                        }}>
                        <Typography variant="body2" sx={{ color: '#94a3b8', mr: 1.5, letterSpacing: '0.05em', textTransform: 'uppercase', fontSize: '0.75rem', fontWeight: 600 }}>
                            Powered by
                        </Typography>
                        <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#fff', letterSpacing: '-0.02em' }}>
                            MG <span style={{ color: '#e3662d' }}>Fintech</span>
                        </Typography>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default OtherProducts;
